/**
 * Created by liwenjun on 2017/7/12.
 * require layer.js
 */
function GetHandler(){
    this.url = "";
    this.onSuccess = function(){};
    this.onError = function(json,msg){
        console.log("服务器返回的数据");
        console.log("GetHandler onError :" + msg);
        console.log(json);
    };
    this.start = function(){
        var loading = layer.load(2);
        var thiz = this;
        $.get(thiz.url, function (json) {
            layer.close(loading);
            switch (json.code) {
                case 0:
                    thiz.onSuccess(json.data);
                    break;
                case 1:
                    thiz.onError(json,"参数错误");
                    break;
                case 3:
                    thiz.onError(json,"服务器错误");
                    break;
                case 301:
                    handlePost301(json.data);
                    break;
                default:
                    thiz.onError(json,"出现了其他错误");

            }
        });
    }
}